import React from 'react';
import { GroupLabel } from 'components/MenuList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var NavMenuItemGroup = function NavMenuItemGroup(_ref) {
  var label = _ref.label,
    children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GroupLabel, {
      as: "li",
      children: label
    }), children]
  });
};
export default NavMenuItemGroup;